<template>
  <div class="tree-item">
    <div v-for="(item,index) in treeData" :key="item.id" class="tagContent">
      <div class="childTag" @click="itemNodeClick(item,false)">
        <div class="child">
          <div class="childLeft" @click="itemNodeClick(item,true)">
            <span>{{ item.name }}</span>
            <i v-if="item.children && item.children.length" :class="isOpen(item.id) ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
          </div>
          <div class="childRight">
            <div v-for="(tag,idx) in item.bqXxbs" :key="idx"  @click="isView?'':tagClick(tag,item)" class="tag cursor" :style="{backgroundColor: tag.color}">
              <div class="tagLeft" :style="{color: tag.color}">
                <img src="@/assets/images/sys/bqgl/tag-icon.png" alt="">
              </div>
              <div class="tagRight">{{ tag.bqLabel }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="item.children && item.children.length" v-show="isOpen(item.id)"  style="padding-top: 12px;padding-left: 24px;">
        <itemTag :treeData="item.children" :defaultExpandedKeys="defaultExpandedKeys" :isView="isView" @nodeClick="$emit('nodeClick', $event)"  @tagClick="$emit('tagClick',$event)"></itemTag>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'itemTag',
  props:{
    treeData: {
      type: Array,
      default: () => []
    },
    isView:{
      type:Boolean,
      default:false
    },
    // 默认展开的节点
    defaultExpandedKeys:{
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      expandedKeys: [] // 当前列表需要展开的节点id组成的数组
    }
  },
  watch:{
    defaultExpandedKeys:{
      handler(newVal){
        this.expandedKeys=[...this.expandedKeys,...newVal]
      },
      deep:true,
      immediate:true,
    }
  },
  methods: {
    // 标签点击
    tagClick(tag,node){
      this.$emit("tagClick", [tag,node]);
      node.bqXxbs.forEach((ele,index)=>{
        if(ele.id == tag.id){
          node.bqXxbs.splice(index,1)
        }
      })
    },
    // 节点点击
    itemNodeClick(item,isExpanded) {
      this.$emit("nodeClick", item);
      if (isExpanded && item.children && item.children.length) {
        let index = this.expandedKeys.indexOf(item.id)
        if (index > -1) {
          // 如果当前节点id存在数组中，则删除
          this.expandedKeys.splice(index, 1)
        } else {
          // 如果当前节点id不存在数组中，则添加
          this.expandedKeys.push(item.id)
        }
      }
    },
    // 子节点是否展开
    isOpen(id) {
      // 判断节点id在不在数组中，在则显示，不在则隐藏
      return this.expandedKeys.includes(id)
    }
  },
}
</script>

<style lang="scss" scoped>
@import url('~@/views/sys/bqgl/style/tag.scss');
.tagContent{
  margin-bottom: 12px;
  border-radius: 5px;
  border: 1px dashed #0c7bf24d;
  background: #fcfcfc;
}
.childTag {
  // padding-left: 24px;

  .child {
    display: flex;
    border: 1px dashed #0c7bf24d;
    background: #fcfcfc;
    color: #2a3347;
    font-weight: bold;
    font-size: 20px;
    // margin-bottom: 12px;
    &:hover {
      background: #F3F6FD;
    }

    .childLeft {
      cursor: pointer;
      padding: 18px 16px;
    }

    .childRight {
      flex: 1;
      padding: 18px 16px;
      border-left: 1px dashed #0c7bf24d;

      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
    }
  }
}
</style>